import { render, staticRenderFns } from "./DeleteCompanyModal.vue?vue&type=template&id=3a014150&scoped=true"
import script from "./DeleteCompanyModal.vue?vue&type=script&lang=js"
export * from "./DeleteCompanyModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteCompanyModal.vue?vue&type=style&index=0&id=3a014150&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a014150",
  null
  
)

export default component.exports